<template>
  <div>
    <div :class="['loading-area', loading ? 'loading' : '']">
      <div :class="['loading-area__content', loading ? 'loading' : '']">
        <div class="vendor-card" v-for="(vendor, key) in vendors" :key="key"
             v-if="vendors.length > 0">
          <div class="grid-x align-middle">
            <div class="cell shrink">
              <div class="vendor-card__image">
                <div class="vendor-card__image__inner">
                  <div class="vendor-card__image__missing"><i class="fas fa-user"></i></div>
                </div>
              </div>
            </div>

            <div class="cell auto">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell auto" style="overflow: hidden; white-space: nowrap;">
                  <div class="vendor-card__name">{{ vendor.name }}</div>
                  <div class="vendor-card__description">for {{ vendor.unpaid }} orders</div>
                </div>

                <div class="cell shrink text-right">
                  <div class="vendor-card__price">{{ vendor.dueDisplay }}</div>

                  <button class="button--small"
                          @click="createPayout(vendor.id, vendor.name, vendor.due, vendor.paypalEmail)">Pay Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p v-if="vendors.length === 0">No commissions due.</p>
      </div>
    </div>

    <transition name="fade">
      <payout v-if="reviewPayout" :vendorId="reviewVendorId"
              :payoutTotal="payoutTotal" :vendorName="reviewVendorName"
              :vendorPayPalEmail="reviewVendorPayPalEmail"
              :lineItemIds="reviewLineItems"
              :payoutAll="true"
              @done="closePayout"></payout>
    </transition>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import payout from '@/globals/payout'

export default {
  mixins: [client, utils],
  components: {
    payout
  },
  data: function () {
    return {
      loading: false,
      reviewPayout: false,
      reviewVendorId: null,
      reviewVendorName: '',
      reviewVendorPayPalEmail: '',
      payoutTotal: 0,
      reviewLineItems: [],
      selectedOrders: [],
      undoSelectAll: true,
      vendors: []
    }
  },
  methods: {
    go: function (id) {
      this.$router.push('/vendors/' + id)
    },
    getVendors: function () {
      this.loading = true

      this.request('get', '/vendors/commission-totals/due/', {
        sort: '-due',
        limit: 5
      }).then(response => {
        let items = response
        this.vendors = []

        for (let i = 0; i < items.length; i++) {
          if (items[i].commission_due > 0) {
            this.vendors.push({
              id: items[i].id,
              name: items[i].name,
              due: items[i].commission_due,
              dueDisplay: this.formatMoney(items[i].commission_due),
              paypalEmail: items[i].paypal_email,
              unpaid: items[i].amount_unpaid
            })
          }
        }

        this.loading = false
      })
    },
    createPayout (vendorId, vendorName, due, vendorPayPalEmail) {
      this.request('get', '/vendors/unpaid-commissions/' + vendorId + '/').then(response => {
        this.reviewPayout = true
        this.reviewVendorId = vendorId
        this.reviewVendorName = vendorName
        this.reviewLineItems = response.line_items
        this.selectedOrders = response.count
        this.payoutTotal = response.amount
        this.undoSelectAll = true
        this.reviewVendorPayPalEmail = vendorPayPalEmail
      })
    },
    closePayout () {
      this.reviewVendorId = null
      this.reviewVendorName = ''
      this.reviewVendorPayPalEmail = ''
      this.payoutTotal = 0
      this.reviewPayout = false

      this.getVendors()
    }
  },
  created () {
    this.getVendors()
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/commissionsDue.vue